import {
  FETCH_ENTITY_ORDERS_BEGIN,
  FETCH_ENTITY_ORDERS_SUCCESS,
  FETCH_ENTITY_ORDERS_FAILURE
} from "../types";

const entityOrdersInitialState = {
  entityOrders: [],
  loading: false,
  error: null
};

export function entityOrders(state = entityOrdersInitialState, action) {
  switch (action.type) {
    case FETCH_ENTITY_ORDERS_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_ENTITY_ORDERS_SUCCESS:
      // All done: set loading "false".
      // Also, replace the entityOrders with the ones from the server
      return {
        ...state,
        loading: false,
        entityOrders: action.data
      };

    case FETCH_ENTITY_ORDERS_FAILURE:
      // The request failed. It's done. So set loading to "false".
      // Save the error, so we can display it somewhere.
      // Since it failed, we don't have  entityOrders to display anymore, so set `entityOrders` empty.
      //
      // This is all up to you and your app though:
      // maybe you want to keep the  entityOrders around!
      // Do whatever seems right for your use case.
      return {
        ...state,
        loading: false,
        error: action.error,
        entityOrders: []
      };
    default:
      return state;
  }
}
